/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prefer-destructuring */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useForm } from 'react-hook-form';

import FileSaver from 'file-saver';
import FileType from 'file-type/browser';
import axios from 'axios';

import {
  MdErrorOutline,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
  MdArrowDropDown,
  MdFileDownload,
  MdCallMade,
  MdArrowDropUp,
} from 'react-icons/md';

import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { Pagination, Row, Col } from 'antd';

import { ClipLoader } from 'react-spinners';

import { IoMdArrowBack } from 'react-icons/io';

import history from '~/services/history';

import { Breadcumbs } from '~/components/Breadcumbs';

import api from '~/services/api';

import { store } from '~/store';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxPagination,
  BoxSuporte,
} from './style';
import { ButtonOrderBy } from '~/components/ButtonOrderBy';
import { toast } from 'react-toastify';

const AreaDeSuporte = ({ location }) => {
  const [data, setData] = useState([]);

  const { state } = location;

  const [contatoSuporte, setContatoSuporte] = useState();

  const [totalCount, setTotalCount] = useState(null);

  const [loading, setLoading] = useState(true);

  const { register, handleSubmit, setValue } = useForm();

  const { token } = store.getState().auth;

  const [searchText, setSearchText] = useState();

  const [noResults, setNoResults] = useState(false);

  const [pageCurrent, setPageCurrent] = useState(1);

  const [hasSearchByLc, setHasSearchByLc] = useState(null);

  const [directionAsc, setDirectionAsc] = useState(true);

  const limit = 5;

  const config = {
    headers: {
      Authorization: token,
      'Content-type': 'application/json',
      Accept: '*/*',
    },
  };

  const [orderBy, setOrderBy] = useState('');

  const getRecursoAjuda = useCallback(
    async props => {
      const order = props?.orderBy || '';
      const filter = props?.filter || '';
      const offset = props?.offset || 0;

      const dir = props?.dir;
      const page = props?.currentPage;

      setHasSearchByLc(null);

      setOrderBy(order);
      setLoading(true);

      try {
        const response = await api.get(
          `recursos-ajuda?limit=${limit}${filter &&
            `&filter=${filter}`}&offset=${offset}${order &&
            `&orderBy=${order}&direction=${dir ? 'asc' : 'desc'}`}`,
          config
        );
        setData(response.data);
        setTotalCount(response.headers['total-count']);
        if (!page) {
          setPageCurrent(1);
        }
        setLoading(false);
        if (response?.data?.length < 1) {
          setNoResults(true);
        }
      } catch (err) {
        setLoading(false);
      }
    },
    [setOrderBy]
  );

  const paginationChange = useCallback(
    async page => {
      setPageCurrent(page);

      const limitOffset = page - 1;
      const offset = page <= 1 ? 0 : limitOffset * limit;

      if (searchText) {
        getRecursoAjuda({
          orderBy: orderBy,
          offset: offset,
          filter: searchText,
          currentPage: page,
          dir: directionAsc,
        });

        return;
      }

      getRecursoAjuda({
        orderBy: orderBy,
        offset: offset,
        currentPage: page,
        dir: directionAsc,
      });
    },
    [orderBy, searchText, setPageCurrent, directionAsc]
  );

  const filterRecurso = useCallback(
    async ({ search }) => {
      setSearchText(search);
      getRecursoAjuda({
        orderBy: orderBy,
        filter: search,
      });
    },
    [orderBy]
  );

  const getContatoSuporte = useCallback(async () => {
    try {
      const response = await api.get(
        `contatos-suporte?limit=5&offset=0`,
        config
      );

      setContatoSuporte(response.data);
    } catch (error) {
      //
    }
  }, []);

  const paginationRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return (
        <a className="arrowLeft">
          <MdKeyboardArrowLeft size={25} /> Anterior
        </a>
      );
    }
    if (type === 'next') {
      return (
        <a className="arrowRight">
          Próximo <MdKeyboardArrowRight size={25} />
        </a>
      );
    }
    return originalElement;
  };

  useEffect(() => {
    if (!state?.searchBy) {
      getRecursoAjuda();
    }

    getContatoSuporte();
  }, [state]);

  const limpaBusca = () => {
    getRecursoAjuda();
    setPageCurrent(1);
    setSearchText(null);
    document.getElementById('search').value = '';

    setHasSearchByLc(null);
  };

  useEffect(() => {
    if (state?.searchBy) {
      setHasSearchByLc(state?.searchBy);
    }
  }, [state]);

  useEffect(() => {
    if (hasSearchByLc) {
      setValue('search', hasSearchByLc);
      setSearchText(hasSearchByLc);
      getRecursoAjuda({
        orderBy: orderBy,
        filter: hasSearchByLc,
      });
    }
  }, [hasSearchByLc]);

  const saveFile = async (nome, url, extensao) => {
    const filename = nome?.replace(/[^A-Z0-9]+/gi, '-');
    const ext = extensao?.toLowerCase();
    
    const res = await axios.get(url, {
      responseType: 'blob',
    });

    const fileBlob = new Blob([res.data], {
      type: 'application/pdf',
    });
    FileSaver.saveAs(fileBlob, `${filename}.${ext}`);
  };

  const DownloadLinkButton = ({ nome, url, extensao }) => {
    return (
      <button
        type="button"
        className="botao-download"
        onClick={() => {
          saveFile(nome, url, extensao);
        }}
      >
        <MdFileDownload size={18} />
        <span>Download</span>
      </button>
    );
  };

  return (
    <>
      <Breadcumbs path="area-de-suporte" pathTitle="Área de suporte" />
      <BreadcumbsContainer>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
      </BreadcumbsContainer>
      <PageTitle>
        <div className="headerInline">
          <span>Área de suporte</span>

          <div className="boxSearch">
            <form onSubmit={handleSubmit(filterRecurso)}>
              <label htmlFor="search">
                <MdSearch size={18} color="#619b30" />
                <input
                  name="search"
                  id="search"
                  placeholder="Buscar recurso"
                  ref={register}
                />
              </label>{' '}
              <button className="botao-verde" type="submit">
                Buscar
              </button>
              <button
                className="limparBusca"
                type="button"
                onClick={() => limpaBusca()}
              >
                Limpar busca
              </button>
            </form>
          </div>
        </div>
      </PageTitle>

      {data.length > 0 ? (
        <>
          <BoxContent>
            <BoxContentHeader>
              <div>
                <ButtonOrderBy
                  isActive={orderBy === 'nome'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getRecursoAjuda({ orderBy: 'nome', dir: !directionAsc });
                  }}
                >
                  <span className="nomeArquivoHeader">
                    Nome do arquivo{' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </div>
              <div>
                <ButtonOrderBy
                  isActive={orderBy === 'assunto'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getRecursoAjuda({ orderBy: 'assunto', dir: !directionAsc });
                  }}
                >
                  <span className="categoriaHeader">
                    Categoria{' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </div>
              <div>
                <ButtonOrderBy
                  isActive={orderBy === 'dataInsercao'}
                  onClick={() => {
                    setDirectionAsc(!directionAsc);
                    getRecursoAjuda({
                      orderBy: 'dataInsercao',
                      dir: !directionAsc,
                    });
                  }}
                >
                  <span className="dataHeader">
                    Data de inserção{' '}
                    {directionAsc ? (
                      <MdArrowDropDown size={20} />
                    ) : (
                      <MdArrowDropUp size={20} />
                    )}
                  </span>
                </ButtonOrderBy>
              </div>
            </BoxContentHeader>

            {data.map(
              ({ id, nome, url, tipo, assunto, dataInsercao, extensao }) => {
                return (
                  <BoxList key={id}>
                    <div className="nomeArquivo">
                      <span>{nome}</span>
                    </div>
                    <div className="categoria">
                      <span>{assunto}</span>
                    </div>
                    <div className="data">
                      <span>
                        {format(
                          new Date(`${dataInsercao}`),
                          'dd/MM/yyyy - k:mm',
                          {
                            locale: ptBR,
                          }
                        )}
                      </span>
                    </div>
                    <div className="buttons">
                      {tipo === 'FILE' ? (
                        <DownloadLinkButton
                          nome={nome}
                          url={url}
                          extensao={extensao}
                        />
                      ) : (
                        <button type="button" className="botao-download">
                          <a
                            href={url}
                            title={nome}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <MdCallMade size={18} />
                            <span>Acessar</span>
                          </a>
                        </button>
                      )}
                    </div>
                  </BoxList>
                );
              }
            )}

            {data.length > 0 && (
              <BoxPagination>
                {!hasSearchByLc && (
                  <Pagination
                    current={pageCurrent}
                    pageSize={limit}
                    onChange={paginationChange}
                    total={Number(totalCount)}
                    itemRender={paginationRender}
                  />
                )}
              </BoxPagination>
            )}
          </BoxContent>

          {contatoSuporte && (
            <BoxSuporte>
              <h2>
                <span>
                  Não encontrou o que procurava? <br />
                  Precisa de ajuda?
                </span>{' '}
                Entre em contato com a equipe de suporte.
              </h2>

              <div className="infoContatos">
                <Row>
                  <Col span={12}>
                    <span>Nome do responsável pelo suporte:</span>
                    <p>{contatoSuporte.nome}</p>
                  </Col>
                  <Col span={10}>
                    <span>E-mail:</span>
                    <p>{contatoSuporte.email}</p>
                  </Col>
                </Row>
              </div>
            </BoxSuporte>
          )}
        </>
      ) : (
        <BoxContent>
          {noResults && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                minHeight: '400px',
                textAlign: 'center',
                color: '#666',
                fontSize: '14px',
              }}
            >
              <MdErrorOutline size="40" color="#666" />
              <br />
              <p style={{ color: '#666' }}>
                Nenhum resultado encontrado, tente com outros termos <br />
                ou limpe a busca.
              </p>
            </div>
          )}
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

export default AreaDeSuporte;
